export default __webpack_public_path__ + "img/thanks.d7864381.svg";